/**
 * Wild Workouts trainer
 * TODO
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Hour from './Hour';

/**
 * The ModelDate model module.
 * @module model/ModelDate
 * @version 1.0.0
 */
class ModelDate {
    /**
     * Constructs a new <code>ModelDate</code>.
     * @alias module:model/ModelDate
     * @param _date {Date} 
     * @param hasFreeHours {Boolean} 
     * @param hours {Array.<module:model/Hour>} 
     */
    constructor(_date, hasFreeHours, hours) { 
        
        ModelDate.initialize(this, _date, hasFreeHours, hours);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, _date, hasFreeHours, hours) { 
        obj['date'] = _date;
        obj['hasFreeHours'] = hasFreeHours;
        obj['hours'] = hours;
    }

    /**
     * Constructs a <code>ModelDate</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ModelDate} obj Optional instance to populate.
     * @return {module:model/ModelDate} The populated <code>ModelDate</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ModelDate();

            if (data.hasOwnProperty('date')) {
                obj['date'] = ApiClient.convertToType(data['date'], 'Date');
            }
            if (data.hasOwnProperty('hasFreeHours')) {
                obj['hasFreeHours'] = ApiClient.convertToType(data['hasFreeHours'], 'Boolean');
            }
            if (data.hasOwnProperty('hours')) {
                obj['hours'] = ApiClient.convertToType(data['hours'], [Hour]);
            }
        }
        return obj;
    }


}

/**
 * @member {Date} date
 */
ModelDate.prototype['date'] = undefined;

/**
 * @member {Boolean} hasFreeHours
 */
ModelDate.prototype['hasFreeHours'] = undefined;

/**
 * @member {Array.<module:model/Hour>} hours
 */
ModelDate.prototype['hours'] = undefined;






export default ModelDate;

